export default "__VITE_ASSET__CMuR9Ktq__"